export function safeJsonParse(value, fallbackValue = null) {
  if (typeof value !== "string" || !value.trim()) {
    return fallbackValue;
  }

  try {
    return JSON.parse(value);
  } catch (_error) {
    return fallbackValue;
  }
}